import { trackedEvent } from "../../../common/events/reduxEventTracking";

enum TypeKeys {
    RESEND_CODE_CLICKED = "PARTY/RESEND_CODE_CLICKED",
}

export const actionCreators = {
    trackResendVerificationCodeClicked: () => trackedEvent({ type: TypeKeys.RESEND_CODE_CLICKED }),
};
